module.exports = __webpack_public_path__ + "static/media/kloie-pellegrini.85af9c16.jpg";